import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { FormFieldErrorMessage } from "~/components/form/error-message";
import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";
import { Switch } from "~/components/switch";

import { Widget, WidgetBody, WidgetHeader } from "../../../_widget";
import { WidgetDecimals } from "../../../widget-form/decimals";
import { WidgetUnit } from "../../../widget-form/unit";
import { WidgetYAxisLabel } from "../../../widget-form/y-axis";
import type { FormState } from "../../../widget-form/y-axis/form-state";
import { SettingsSectionFormField } from "../_field";
import { SettingsSectionGrid } from "../_section-grid";

interface LabelsProps {
	yAxis: FormState;
}

export const Labels: React.FC<LabelsProps> = ({ yAxis }) => {
	const monitor = useMonitor();
	const enabled = yAxis.enabled.getInput(monitor);

	return (
		<Widget>
			<WidgetHeader className="grid-cols-[auto_auto_1fr] uppercase" title="Y-axis Labels">
				<Switch
					checked={enabled}
					name="dashboard-widget-y-axis-show"
					onCheckedChange={(show) => yAxis.enabled.setInput(show)}
				/>

				<FormFieldReset className="ml-auto" state={yAxis} />
			</WidgetHeader>

			<WidgetBody card>
				<SettingsSectionGrid className="grid-cols-[auto_1fr]">
					<SettingsSectionFormField layout="horizontal" state={yAxis.element.fields.unit}>
						<FormLabel>Unit</FormLabel>

						<WidgetUnit className="w-full" default={undefined} disabled={!enabled} unit={yAxis.element.fields.unit} />
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={yAxis.element.fields.decimals}>
						<FormLabel>Decimals</FormLabel>

						<WidgetDecimals
							decimals={yAxis.element.fields.decimals}
							disabled={!enabled}
							name="dashboard-widget-settings-decimal-places"
						/>

						<FormFieldErrorMessage className="col-span-full" />
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={yAxis.element.fields.label}>
						<FormLabel>Label</FormLabel>

						<WidgetYAxisLabel
							disabled={!enabled}
							label={yAxis.element.fields.label}
							name="dashboard-widget-y-axis-label"
						/>
					</SettingsSectionFormField>
				</SettingsSectionGrid>
			</WidgetBody>
		</Widget>
	);
};
